<script lang="ts">
  import FieldContainer from "../internal/FieldContainer.svelte";
  import InnerContainer from "../internal/InnerContainer.svelte";
  import TitleDescription from "../internal/TitleDescription.svelte";
  import OVIcon from "$components/+shared/OVIcon/OVIcon.svelte";
  import type { IconType } from "$components/+shared/OVIcon/OVIcon";
  import Avatar from "$components/+shared/Avatar/Avatar.svelte";
  import cx from "classnames";

  export let href: string;
  export let title: string;
  export let newTab: boolean = false;
  export let icon: IconType | undefined = undefined;
  export let avatar: string | undefined = undefined;
  export let reverseOrder: boolean = false;
  export let tooltipCopy: string = "";
</script>

<FieldContainer {title} closeOnTrigger>
  <!-- noopener noreferrer is a security measure to prevent reverse tabnabbing -->
  <a {href} target={newTab ? "_blank" : null} rel={newTab ? "noopener noreferrer" : null}>
    <InnerContainer {reverseOrder} {tooltipCopy}>
      {#if icon && !avatar}
        <OVIcon
          {icon}
          size={cx({ "w-3.5 h-3.5": reverseOrder, "w-4 h-4": !reverseOrder })}
          class={cx({ "ml-auto": reverseOrder })}
        />
      {:else if avatar}
        <Avatar
          radius="rounded-[3px]"
          mainImage={avatar}
          label={title[0]}
          wrapperClasses="bg-transparent"
        />
      {/if}

      <TitleDescription {title} />
    </InnerContainer>
  </a>
</FieldContainer>
